module.exports = __webpack_public_path__ + "img/logo_tam_blanco.f2c8c7db.png";